import logo from './logo.svg';
import './App.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'bootstrap';
import NavigationBar from './components/navbar/NavigationBar';
import SliderCarousel from './components/slider/SliderCarousel';
import { Route, Routes } from 'react-router-dom';
import Hakkimizda from "./components/pages/hakkimizda/Hakkimizda";
import Paydaslar from './components/pages/paydaslar/Paydaslar';
import Anasayfa from './components/pages/anasayfa/Anasayfa';
import Danisma from './components/pages/danisma/Danisma';
import Duzenleme from './components/pages/duzenleme/Duzenleme';
// import Organizasyon from './components/pages/organizasyon/Organizasyon';
import Koordinasyon from './components/pages/koordinasyon/Koordinasyon';
import Odeme from './components/pages/odeme/Odeme';
import Iletisim from './components/pages/iletisim/Iletisim';
import FuarYeri from './components/pages/fuarYeri/FuarYeri';
import KayitOl from './components/pages/kayitol/KayitOl';
import Footer from './components/footer/Footer';
import SponsorlukBilgileri from './components/pages/sponsor/sponsorlukBilgileri/SponsorlukBilgileri';
import AnaSponsorlar from './components/pages/sponsor/anaSponsorlar/AnaSponsorlar';
import AltinSponsorlar from './components/pages/sponsor/altinSponsorlar/AltinSponsorlar';
import GumusSponsorlar from './components/pages/sponsor/gumusSponsorlar/GumusSponsorlar';
import BronzSponsorlar from './components/pages/sponsor/bronzSponsorlar/BronzSponsorlar';
import KatilimciOlBilgileri from './components/pages/katilimci/katilimciOlBilgileri/KatilimciOlBilgileri';
import KatilimciKurumFirmalar from './components/pages/katilimci/katilimciKurumFirmalar/KatilimciKurumFirmalar';
import Contents from './components/contents/Contents';
import Content from './components/content/Content';
import KariyerMerkezleri from './components/pages/kariyerMerkezleri/KariyerMerkezleri';
import Haberler from './components/pages/haberler/Haberler';
import Katalog from './components/pages/katalog/Katalog';
import Konusmacilar from './components/konusmacilar/Speakers';
import Etkinlikler from './components/etkinlikler/Speakers';

function App()
{
  return (
    <div>
      <NavigationBar />
      <Routes>
        <Route path='/hakkimizda' element={<Hakkimizda />} ></Route>
        <Route path='/paydaslar' element={<Paydaslar />} ></Route >
        <Route path='/duzenleme' element={<Duzenleme />} ></Route >
        <Route path='/danisma' element={<Danisma />} ></Route >
        {/* <Route path='/organizasyon' element={<Organizasyon />} ></Route > */}
        <Route path='/koordinasyon' element={<Koordinasyon />} ></Route >
        <Route path='/odeme' element={<Odeme />} ></Route >
        <Route path='/kayitol' element={<KayitOl />} ></Route >
        <Route path='/iletisim' element={<Iletisim />} ></Route >
        <Route path='/fuaryeri' element={<FuarYeri />} ></Route >
        <Route path='/contents' element={<Contents />} ></Route >
        <Route path='/content/:uri' element={<Content />} ></Route >
        <Route path='/anasayfa' element={<Anasayfa />} ></Route >
        <Route path='/sponsorlukbilgileri' element={<SponsorlukBilgileri />} ></Route >
        <Route path='/anasponsorlar' element={<AnaSponsorlar />} ></Route >
        <Route path='/altinsponsorlar' element={<AltinSponsorlar />} ></Route >
        <Route path='/gumussponsorlar' element={<GumusSponsorlar />} ></Route >
        <Route path='/bronzsponsorlar' element={<BronzSponsorlar />} ></Route >
        <Route path='/katilimciolbilgileri' element={<KatilimciOlBilgileri />} ></Route >
        <Route path='/katilimcikurumfirmalar' element={<KatilimciKurumFirmalar />} ></Route >
        <Route path='/kariyermerkezleriiletisim' element={<KariyerMerkezleri />} ></Route >
        <Route path='/haberler' element={<Haberler />} ></Route >
        <Route path='/katalog' element={<Katalog />} ></Route >
        <Route path='/konusmacilar' element={<Konusmacilar />} ></Route >
        <Route path='/etkinlikler' element={<Etkinlikler />} ></Route >


        <Route path='/' element={<Anasayfa />} ></Route >
      </Routes>
      <Footer></Footer>
    </div>
  );
}

export default App;